import { useState } from 'react';

import { TableCell, TableRow, Typography, Box, Button } from '@mui/material';
import { Dialog } from 'style-guide';
import AddServiceProvider from './AddServiceProvider';
import { useSelector } from 'react-redux';

const RowCustomer = ({ data, consigneeList }) => {
    const { countryOfOriginData, serviceProviderType } = useSelector(state => state.predefinedData);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const [newData, setNewData] = useState(false);
    const onHandleOpenModal = () => {
        var nData = { ...data }
        nData.iuser = Number(data.iuser);
        nData.ouser = Number(data.ouser);
        nData.cuser = Number(data.cuser);
        setNewData(nData);
        setOpenOrderModal(true);
    }
    const onHandleCancelModal = () => setOpenOrderModal(false);
    const { usersLocation } = useSelector(state => state.users);
    const inActiveBgColor = {
        'background-color': '#F5F5F5'
    }

    const getDate = (date) => {
        var sp = date.split("-");
        return sp[2] + "/" + sp[1] + "/" + sp[0];
    }

    return (
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} style={(data.active == null || data.active) ? null : inActiveBgColor}>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.companyName?.substring(0, 11) || '-'} ({data?.serviceProviderLocationId != null ? usersLocation?.find(location => location.id === data?.serviceProviderLocationId)?.code : "NL"})
                </p>
            </TableCell>
            {/*<TableCell colspan={2}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {countryOfOriginData.find(country => country.id === data.countryId)?.name || '-'}
                </p>
            </TableCell>*/}
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.city?.substring(0, 11) || '-'}
                </p>
            </TableCell>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.code?.substring(0, 11) || '-'}
                </p>
            </TableCell>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.name?.substring(0, 11) || '-'}
                </p>
            </TableCell>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.phone?.substring(0, 11) || '-'}
                </p>
            </TableCell>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.mobile?.substring(0, 11) || '-'}
                </p>
            </TableCell>
            <TableCell colSpan={1} style={{ width: "32%" }}>
                <div variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px", maxWidth: "30vw", overflow: "hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.reminderText || '-'}
                </div>
            </TableCell>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.reminderDate ? getDate(data.reminderDate?.substring(0, 10)) : '-'}
                </p>
            </TableCell>
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.commercial?.substring(0, 11) || '-'}
                </p>
            </TableCell>
            {/*<TableCell colspan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {data.uatnumber || '-'}
                </p>
            </TableCell>*/}
            <TableCell colSpan={1}>
                <p variant='body1' component='span' style={{ textAlign: "left", marginLeft: "10px" }}>
                    {(data.crmStatus != null) ? (data.crmStatus == 2 ? 'Lead' : 'Account') : ''}
                </p>
            </TableCell>
            <TableCell colSpan={1}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button onClick={onHandleOpenModal} variant='outlined' sx={{ mr: 1 }}>
                        Edit
                    </Button>
                    {openOrderModal && (
                        <Dialog
                            maxWidth='md'
                            open={openOrderModal}
                            title={'CRM'}
                            onHandleCancel={onHandleCancelModal}>
                            <AddServiceProvider data={newData} onHandleCancel={onHandleCancelModal} id={null} readOnly={false} consigneeList={consigneeList} loginUser={loginUser} />
                        </Dialog>
                    )}
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default RowCustomer;
